import loggingService from '../services/util/loggingService'

var serviceName = 'mapReferenceService'
var path = '/Lookup/MapReference/'
var isDebug = false

function listLookup (http) {
    loggingService.log(isDebug, serviceName, 'ListLookup')

    return http.get(path + 'ListLookup')
}

export default {
    listLookup: listLookup
}



// WEBPACK FOOTER //
// ./src/services/mapReferenceService.js